<template>
  <Evaluasi halaman="evaluasi1" />
</template>

<script>
import Evaluasi from '../components/Evaluasi'

export default {
  components: {
    Evaluasi
  }
}
</script>

